import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommSearchIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M11.0497 1.75C5.91356 1.75 1.74988 5.91369 1.74988 11.0499C1.74988 16.186 5.91356 20.3497 11.0497 20.3497C13.3479 20.3497 15.4513 19.5161 17.0742 18.1348L20.9697 22.0304C21.2626 22.3232 21.7374 22.3232 22.0303 22.0304C22.3232 21.7375 22.3232 21.2626 22.0303 20.9697L18.1348 17.0742C19.516 15.4513 20.3496 13.3479 20.3496 11.0499C20.3496 5.91369 16.1859 1.75 11.0497 1.75ZM3.24988 11.0499C3.24988 6.74211 6.74199 3.25 11.0497 3.25C15.3575 3.25 18.8496 6.74211 18.8496 11.0499C18.8496 15.3576 15.3575 18.8497 11.0497 18.8497C6.74199 18.8497 3.24988 15.3576 3.24988 11.0499Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
